module.exports = __webpack_public_path__ + "img/regent.a680ed73.jpg";